'use es6';

import { getHubUsers, getOwnedAddresses } from 'FormsUI/api/Users';
function createAction(name) {
  return `@@hubUsers/${name}`;
}
export const REQUEST_HUB_USERS = createAction('REQUEST_HUB_USERS');
export const RECEIVE_HUB_USERS = createAction('RECEIVE_HUB_USERS');
export const SUCCEED_GETTING_HUB_USERS = createAction('SUCCEED_GETTING_HUB_USERS');
export const FAILED_GETTING_HUB_USERS = createAction('FAILED_GETTING_HUB_USERS');
export function requestHubUsers() {
  return {
    type: REQUEST_HUB_USERS
  };
}
export const receiveHubUsers = (users, ownedAddresses) => ({
  type: RECEIVE_HUB_USERS,
  hubUsers: users,
  ownedAddresses
});
export function succeedGettingHubUsers() {
  return {
    type: SUCCEED_GETTING_HUB_USERS
  };
}
export function failGettingHubUsers() {
  return {
    type: FAILED_GETTING_HUB_USERS
  };
}
export function fetchHubUsers(query) {
  return dispatch => {
    dispatch(requestHubUsers());
    Promise.all([getHubUsers(query), getOwnedAddresses()]).then(([users, ownedAddresses]) => {
      dispatch(succeedGettingHubUsers());
      dispatch(receiveHubUsers(users, ownedAddresses));
    }).catch(error => {
      dispatch(failGettingHubUsers(error));
    });
    return undefined;
  };
}